document.addEventListener("DOMContentLoaded", function () {
  var fixedHeaderHeight = 130;
  var fixDom = document.querySelector(".faq-options");
  var faqTagLinks = document.querySelectorAll(".faq-options .item");
  
  faqTagLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      var selectText = link.textContent.trim().toLowerCase();
      var faqs = document.querySelectorAll("#MainContent .collapsible-content");

      faqTagLinks.forEach(function (item) {
        item.classList.remove("on");
      });
      link.classList.add("on");

      // 遍历所有faq
      for (var i = 0; i < faqs.length; i++) {
        var faq = faqs[i];
        var title = faq
          .querySelector(".collapsible-content__header")
          .textContent.trim()
          .toLowerCase();

        if (title === selectText) {
          // 使用原生JavaScript实现滚动动画
          window.scrollTo({
            top: faq.offsetTop - fixedHeaderHeight,
            behavior: "smooth",
          });
        }
      }
    });
  });

  function calcFixed() {
    var top = document.querySelector(
      "#MainContent .section--collapsible-content"
    ).offsetTop;
    var fixDomOffset = 85;
    var scrollTop = window.scrollY + fixDomOffset;
    var optionsHeight = document.querySelector("#MainContent").clientHeight - 330;
    var fixDomHeight = fixDom.clientHeight;

    if (optionsHeight - scrollTop + fixDomOffset < fixDomHeight) return;
    if (scrollTop > top) {
      fixDom.style = "top: " + (scrollTop - top + fixedHeaderHeight) + "px";
    } else {
      fixDom.style = "";
    }
  }

  calcFixed();

  window.addEventListener("resize", calcFixed);
  window.addEventListener("scroll", calcFixed);

  // 搜索faq
  // var faqNameInput = document.querySelector("#faq-name");

  // faqNameInput.addEventListener("keyup", function(e) {
  //   if (e.keyCode === 13) {
  //     searchFaq();
  //   }
  // });

  // var faqButton = document.querySelector(".faq-button");

  // faqButton.addEventListener("click", searchFaq);

  // function searchFaq() {
  //   var faqs = document.querySelectorAll("#MainContent details");
  //   var searchStr = faqNameInput.value.toLowerCase();

  //   // 移除所有faq的highlight类
  //   faqs.forEach(function(faq) {
  //     faq.classList.remove("highlight");
  //   });

  //   if (searchStr) {
  //     // 遍历所有faq
  //     for (var i = 0; i < faqs.length; i++) {
  //       var faq = faqs[i];
  //       var title = faq.querySelector("summary").textContent.toLowerCase();
  //       var content = faq.querySelector(".accordion__content").textContent.toLowerCase();

  //       if (title.match(searchStr) || content.match(searchStr)) {
  //         faq.classList.add("highlight");

  //         // 使用原生JavaScript实现滚动动画
  //         window.scrollTo({
  //           top: faq.offsetTop - 80,
  //           behavior: 'smooth'
  //         });
  //         break;
  //       }
  //     }
  //   }
  // }
});
